import React from 'react';
import styled from 'styled-components';

interface CenteredLayoutProps {
  children: React.ReactNode;
  backgroundColor?: string;
  className?: string;
}

const Container = styled.div<{
  $backgroundColor: string;
}>`
  width: 100%;
  background-color: ${props => props.$backgroundColor};
  box-sizing: border-box;
  padding: 90px 16px 0 16px; /* 웹 앱바 높이만큼 상단 패딩 추가 */
  
  /* 모바일에서는 가운데 정렬 및 수평 스크롤 방지 */
  @media (max-width: 767px) {
    display: flex;
    justify-content: center;
    overflow-x: hidden;
    padding: 60px 16px 0 16px; /* 모바일 앱바 높이 고정값 사용 */
  }
  
  /* 768px ~ 1199px: 가로 스크롤 허용 (UI 깨짐 방지) */
  @media (min-width: 768px) and (max-width: 1199px) {
    display: block;
    min-width: 1232px; /* 1200px + 좌우 패딩 32px */
    overflow-x: auto;
    min-height: calc(100vh - 100px); /* 앱바 높이를 제외한 나머지 공간 */
  }
  
  /* 1200px 이상: 중앙 정렬, 가로 스크롤 방지 */
  @media (min-width: 1200px) {
    display: flex;
    justify-content: center;
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  
  /* 모바일에서는 전체 너비 사용 */
  @media (max-width: 767px) {
    max-width: 100%;
    min-width: auto;
  }
  
  /* 768px ~ 1199px: 1200px 고정 너비 (가로 스크롤로 UI 보호) */
  @media (min-width: 768px) and (max-width: 1199px) {
    width: 1200px;
    margin: 0 auto;
  }
  
  /* 1200px 이상: 1200px 고정, 중앙 정렬 */
  @media (min-width: 1200px) {
    width: 1200px;
    max-width: calc(100vw - 32px); /* 좌우 패딩 고려 */
    margin: 0 auto;
  }
`;

const CenteredLayout: React.FC<CenteredLayoutProps> = ({
  children,
  backgroundColor = '#fff',
  className,
}) => {
  return (
    <Container 
      $backgroundColor={backgroundColor} 
      className={className}
    >
      <Content>
        {children}
      </Content>
    </Container>
  );
};

export default CenteredLayout;
